import { useState, useEffect, useContext } from "react";

import "./EUMRVVoyages.scss";
import CustomTable from "../../../../../../common/customTable/CustomTable";
import { useSelector } from "react-redux";
import { ClaimsContext } from "../../../../../../services/ClaimsService";

const EUMRVVoyagesOld = ({ data, loading }) => {
	const { userHasClaim } = useContext(ClaimsContext);
	const user = useSelector((state) => state.userInfo.userData);
	const [columnsData, setColumnsData] = useState([]);

	useEffect(() => {
		(async () => {
			const { EUMRVVoyageOldColumnsData } = await import(
				"../../../../../../constants/CustomTableHeaders"
			);
			const alwaysShowColumns = EUMRVVoyageOldColumnsData?.filter(
				(column) => !column.condition
			);
			const conditionalColumns = EUMRVVoyageOldColumnsData?.filter(
				(column) =>
					column.condition && userHasClaim(column.condition)
			);
			setColumnsData([...alwaysShowColumns, ...conditionalColumns]);
		})();
	}, [user]);

	return (
		<>
			<div className="EUMRV-custom-table-container mt-2">
				<CustomTable
					columnsData={columnsData.length > 0 ? columnsData : []}
					renderTableData={data || []}
					customProps={{
						isLoading: loading,
						enableToptoolbar: false,
						enableSort: false,
					}}
				/>
			</div>
		</>
	);
};

export default EUMRVVoyagesOld;
